// Contact configuration file
// This file contains global variables for contact information that can be used across the application

import { Phone, Email, LocationOn } from '@mui/icons-material';
import React from 'react';

// Office hours configuration
export const officeHours = {
  weekdays: {
    days: 'Monday - Friday',
    hours: '8:00 AM - 4:00 PM'
  }
};

// Contact methods configuration
// These will be used with theme-aware colors in components
export const getContactMethods = (theme) => [
  {
    icon: <Phone />,
    title: 'Call Us',
    details: ['(704) 450-9009'],
    color: theme.palette.success.main
  },
  {
    icon: <Email />,
    title: 'Email Us',
    details: ['info@eaglesrefugeacademy.com'],
    color: theme.palette.info.main
  },
  {
    icon: <LocationOn />,
    title: 'Visit Us',
    details: ['109 Eagles Refuge Drive Statesville, NC 28625'],
    color: theme.palette.primary.main
  }
];

// Contact form options
export const timeOptions = [
  'Morning (8:00 AM - 12:00 PM)',
  'Afternoon (12:00 PM - 4:00 PM)',
  'Evening (4:00 PM - 6:00 PM)',
  'Anytime'
];

export const methodOptions = [
  'Phone Call',
  'Email',
  'Text Message',
  'No Preference'
];